import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_workspace_update } from '@/state/workspace/entity/remote_workspace_update';
import { useTranslation } from 'react-i18next';

export function W_CHECKBOX__refresh_link_after_usage() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();
  const { toast } = useToast();

  const { t } = useTranslation([ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE, ENUM__i18n_namespace.BASE_UI]);

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  /*
   * EVENTS
   */

  async function onCheckedChange() {
    let workspace_new = workspace_current.clone({ refresh_invite_link_after_usage: !workspace_current.refresh_invite_link_after_usage });
    await dispatch(remote_workspace_update(workspace_new));

    if (workspace_new.refresh_invite_link_after_usage) {
      toast({ title: t(i18n_base_ui.toasts.checkbox_refresh_link_after_usage.title) });
    }
  }

  /*
   * HTML
   */

  return (
    <div className="flex items-center mt-2">
      <UI_PRIMITIVE__checkbox
        id="WCheckboxRefreshLinkAfterUsage"
        checked={workspace_current.refresh_invite_link_after_usage}
        disabled={!workspace_current.invite_by_link_enabled}
        {...{ onCheckedChange }}
        className={`${workspace_current.invite_by_link_enabled ? '' : 'opacity-50'}`}
      />
      <label
        htmlFor="WCheckboxRefreshLinkAfterUsage"
        className={`ml-2 text-sm cursor-pointer ${workspace_current.refresh_invite_link_after_usage ? '' : 'opacity-50'} 
        ${workspace_current.invite_by_link_enabled ? '' : 'opacity-50 !cursor-not-allowed'}
        `}
      >
        {t(i18n_page_settings_workspace.tabs.users.shared.invite_by_link_component.checkbox.refresh)}
      </label>
    </div>
  );
}
